import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "services";
import * as Actions from "actions";
import Common from "us.common";
import { TemplateEditor } from "constants/Actions";
import _ from "lodash";
import { DEFAULT_DRAWER_STATE } from "constants/TemplateEditor";

const { $MessageBox } = Common.Components;
const { templateEditor } = Actions;

const { parameterList, sections, adapters, template, previewData } =
  API.templateEditor;
const {
  GET_PARAMETERS,
  GET_SECTIONS,
  GET_TEMPLATE_RULES,
  SAVE_TEMPLATE_RULE,
  GET_PREVIEW_DATA,
  GET_REPEATING_ADAPTERS,
  GET_REPEATING_ADAPTER_TOKENS,
  GET_TEMPLATE_PREVIEW,
} = TemplateEditor;

const TemplateEditorSagas = {
  template: {
    getRules: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(template.getRules, params);
        if (status === 200) {
          yield put(templateEditor.templateRules.success(data));
        } else {
          yield put(templateEditor.templateRules.fail([]));
        }
      } catch (error) {
        yield put(templateEditor.templateRules.fail([]));
      }
    },
    saveRule: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { rulesData, rulesStatus, saveStatus } = yield call(
          template.saveRule,
          params
        );
        if (saveStatus === 200) {
          yield put(templateEditor.templateRule.success([]));
          $MessageBox(
            "success",
            `US.USC.TEMPLATEEDITOR:MESSAGES.TEMPLATE_RULE_UPDATED_SUCCESSFULLY`,
            "",
            ""
          );
          if (rulesStatus == 200) {
            yield put(templateEditor.templateRules.success(rulesData));
            if (templateEditor.templateRules.manageDrawer)
              yield put(
                templateEditor.templateRules.manageDrawer(DEFAULT_DRAWER_STATE)
              );
          }
        } else {
          yield put(templateEditor.templateRule.fail([]));
          $MessageBox(
            "error",
            `US.USC.TEMPLATEEDITOR:MESSAGES.SAVE_TEMPLATE_RULE_FAILED`,
            "",
            ""
          );
        }
      } catch (error) {
        yield put(templateEditor.templateRule.fail([]));
        $MessageBox(
          "error",
          `US.USC.TEMPLATEEDITOR:MESSAGES.SAVE_TEMPLATE_RULE_FAILED`,
          "",
          ""
        );
      }
    },
    getPreview: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(template.getPreview, params);
        if (status === 200) {
          yield put(templateEditor.templatePreview.success(data));
        } else {
          yield put(templateEditor.templatePreview.fail([]));
        }
      } catch (error) {
        yield put(templateEditor.templatePreview.fail([]));
      }
    },
  },
  parameters: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(parameterList.get, params);
        if (Array.isArray(data) && status === 200) {
          yield put(templateEditor.parameters.success(data));
        } else {
          yield put(templateEditor.parameters.success([]));
        }
      } catch (error) {
        yield put(templateEditor.parameters.fail([]));
      }
    },
  },
  sections: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(sections.get, params);
        if (Array.isArray(data) && status === 200) {
          yield put(templateEditor.sections.success(data));
        } else {
          yield put(templateEditor.sections.success([]));
        }
      } catch (error) {
        yield put(templateEditor.sections.fail([]));
      }
    },
  },
  repeatingAdapters: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(adapters.byCategoryId, params);
        if (Array.isArray(data) && status == 200 && data.length > 0) {
          yield put(templateEditor.repeatingAdapters.success(data));
        } else {
          yield put(templateEditor.repeatingAdapters.fail([]));
        }
      } catch (error) {
        yield put(templateEditor.repeatingAdapters.fail([]));
      }
    },
    getTokens: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(parameterList.get, params);
        if (Array.isArray(data) && status == 200) {
          yield put(templateEditor.repeatingAdapterTokens.success(data));
        } else {
          yield put(templateEditor.repeatingAdapterTokens.success([]));
        }
      } catch (error) {
        yield put(templateEditor.repeatingAdapterTokens.fail([]));
      }
    },
  },
  previewData: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(previewData.get, params);
        if (Array.isArray(data) && status === 200) {
          yield put(templateEditor.previewData.success(data));
        } else {
          yield put(templateEditor.previewData.success([]));
        }
      } catch (error) {
        yield put(templateEditor.previewData.fail([]));
      }
    },
  },
};

export default [
  takeLatest(GET_PARAMETERS, TemplateEditorSagas.parameters.get),
  takeLatest(GET_SECTIONS, TemplateEditorSagas.sections.get),
  takeLatest(GET_TEMPLATE_RULES, TemplateEditorSagas.template.getRules),
  takeLatest(SAVE_TEMPLATE_RULE, TemplateEditorSagas.template.saveRule),
  takeLatest(GET_PREVIEW_DATA, TemplateEditorSagas.previewData.get),
  takeLatest(GET_REPEATING_ADAPTERS, TemplateEditorSagas.repeatingAdapters.get),
  takeLatest(
    GET_REPEATING_ADAPTER_TOKENS,
    TemplateEditorSagas.repeatingAdapters.getTokens
  ),
  takeLatest(GET_TEMPLATE_PREVIEW, TemplateEditorSagas.template.getPreview),
];
